import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';
const License = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>使用者協議</h2>
            <p>軟體許可及使用者協議</p>
            <p>歡迎您使用Dreamehome軟體及服務<strong> </strong></p>
            <p>為使用Dreamehome軟體及服務，追覓創新科技（蘇州）有限公司以及其關聯公司（以下簡稱「追覓」）在此特別提醒使用者認真閱讀、充分理解本《軟體許可及使用者協議》（下稱「本協議」）及《Dreamehome隱私政策》。使用者應認真閱讀、充分理解本協議中各條款，特別涉及免除或者限制責任、爭議解決和法律適用的條款。免除或者限制責任的條款將以粗體標識，您需要詳細閱讀。請您審慎閱讀並選擇接受或不接受本協議（未成年人應在法定監護人陪同下閱讀）。您的下載、安裝、使用本軟體以及帳號獲取和登入等行為將視為對本協議的接受，並同意接受本協議各項條款的約束。<br /><br />一、總則
            </p>
            <p>1.1.
                本協議是您（以下也稱「使用者」，指的是註冊、登入、使用、瀏覽本軟體及服務的個人或組織）與追覓及其運營合作單位（以下簡稱「合作單位」）之間關於使用者下載、安裝、使用「Dreamehome」軟體（以下稱「本軟體」）以及使用追覓相關服務所訂立的協議。
            </p>
            <p>1.2. 本軟體及服務是追覓提供的安裝在包括但不限於行動智慧終端裝置（如手機、平板、電腦及其他等）的軟體和服務，為使用該智慧終端的使用者提供帳戶綁定、操作智慧產品等服務等。</p>
            <p>二、軟體的獲取</p>
            <p>2.1. 使用者應當依照追覓的官網、官方應用平台以及追覓授權的第三方網站、應用軟體分發平台等追覓官方或追覓授權的管道下載獲取本軟體產品。</p>
            <p>2.2
                請您謹防在非指定追覓官方或追覓授權的第三方獲取本軟體，以免終端裝置感染能破壞使用者資料和獲取使用者隱私資訊的惡意程式。如果使用者從未經追覓授權的第三方獲取本軟體或與本軟體名稱相同的安裝程式，追覓無法保證該軟體能夠正常使用，並對因此給您造成的損失不予負責。
            </p>
            <p>三、軟體的安裝與解除安裝</p>
            <p>3.1. 使用者必須選擇與所安裝終端設備相容的本軟體版本，否則，由於軟體與裝置型號不相容所導致的任何軟體問題、裝置問題或損害，均由使用者自行承擔。</p>
            <p>3.2 因經營策略安排或調整等原因，不同地區的使用者可使用Dreamehome服務的內容可能會有所差異，具體以Dreamehome實際可提供的為準。</p>
            <p>3.3 如您不再需要使用本軟體或需要安裝新版軟體，可以自行解除安裝。</p>
            <p>3.4 軟體新版本釋出後，追覓不保證舊版本軟體的繼續可用。</p>
            <p>3.5
                為了改善使用者體驗、完善服務內容，追覓有權不時地為您提供本軟體替換、修改、升級版本，也有權為替換、修改或升級收取費用，但將收費提前徵得您的同意。本軟體為使用者預設開通“升級提示”功能，視使用者使用的軟體版本差異，追覓供給使用者自行選擇是否需要開通此功能。軟體新版本釋出後，追覓不保證舊版本軟體的繼續可用。
            </p>
            <p>四、軟體的更新</p>
            <p>4.1 為了增進使用者體驗、完善服務內容，追覓將不斷努力開發新的服務功能，並為您不時提供軟體更新。</p>
            <p>4.2 為了改善使用者體驗或提高服務安全性、保證功能的一致性等目的，追覓有權對本軟體進行更新，或者對軟體的部分功能效果進行改變。</p>
            <p>4.3 本軟體新版本釋出後，舊版本的軟體可能無法使用。追覓不保證舊版本軟體繼續可用，也不保證繼續對舊版本軟體提供相應的客服和維護服務，請您隨時核對並下載最新版本。</p>
            <p>五、使用規範</p>
            <p><strong>5.1. </strong>使用者註冊與帳號：</p>
            <ul>
                <li>5.1. 要使用Dreamehome軟體服務，使用者必須註冊一個使用者帳戶（以下簡稱您的「帳戶」）並在提示的登錄檔中提供關於您自己的特定資訊。 您同意您所提交的所有資訊均真實準確並且您會及時更新此類資訊。</li>
                <li>5.1.2
                    創建帳戶或使用Dreamehome軟體，即表示您確認並接受本協議。您也確認您根據您所在的國家的法律上已經成年；或者您根據您所在的國家的法律還未成年（「未成年人」），且您表明您已與您的父母或法定監護人共同閱讀本協議，且您和您的父母或監護人理解並同意本條款的條款和條件。如果您是父母或監護人，允許未成年人使用本軟體及服務，即表示您同意：(i)
                    監督未成年人使用本軟體及服務；(ii) 承擔與未成年人使用本軟體及服務相關的所有風險；(iii)承擔因未成年人使用本軟體及服務導致的任何法律責任；(iv) 確保您或未成年人提交的所有資訊準確、真實；以及 (v)
                    承擔未成年人訪問和使用本軟體及服務導致的任何責任並接受本條款約束。</li>
                <li>5.1.3 使用者應當按照法律法規和服務要求，按相應頁面的提示準確提供並及時更新使用者帳號的資料，以使之真實、及時、完整和準確。</li>
                <li>5.1.4 帳號的所有權歸追覓所有，使用者完成申請註冊手續後，僅獲得帳號的使用權，且該使用權僅屬於初始申請註冊人。</li>
                <li>5.1.5 使用者有責任妥善保管註冊帳戶資訊及帳戶密碼的安全，使用者需要對註冊帳戶以及密碼下的行為承擔法律責任。使用者同意在任何情況下不向他人透露帳戶及密碼資訊。當在你懷疑他人在使用你的帳號時，你應立即通知追覓。
                </li>
            </ul>
            <p><strong>5.2. </strong>使用者禁止的行為：</p>
            <ul>
                <li>5.2.1. 刪除本軟體及其他副本上一切關於版權的資訊，以及修改、刪除或迴避本軟體為保護智慧財產權而設定的技術措施；</li>
                <li>5.2.2. 對本軟體進行逆向工程，如逆向彙編、逆向編譯或者其他試圖獲得本軟體的原始碼；</li>
                <li>5.23. 透過修改或偽造軟體執行中的指令、資料，增加、刪減、變動軟體的功能或執行效果，或者將用於上述用途的軟體、方法進行運營或向公眾傳播，無論這些行為是否為商業目的；</li>
                <li>5.2.4.
                    使用本軟體進行任何危害網絡安全的行為，包括但不限於：使用未經許可的資料或進入未經許可的伺服器/帳戶；未經允許進入公眾網絡或者他人作業系統並刪除、修改、增加儲存資訊；未經許可企圖探查、掃描、測試本軟體的系統或網路的弱點或其它實施破壞網路安全的行為；
                    企圖干涉、破壞本軟體系統或網站的正常執行，故意傳播惡意程式或病毒以及其他破壞干擾正常網路資訊服務的行為；偽造TCP/IP資料包名稱或部分名稱；</li>
                <li>5.2.5. 使用者透過非追覓公司開發、授權或認可的第三方相容軟體、系統登入或使用本軟體及服務，或製作、釋出、傳播上述工具；</li>
                <li>5.2.6.
                    未經追覓書面同意，使用者對軟體及其中的資訊擅自實施包括但不限於下列行為：使用、出租、出借、複製、修改、連結、轉載、彙編、發表、出版，建立映象站點、擅自藉助本軟體發展與之有關的衍生產品、作品、服務、插件、外掛、相容、互聯等；
                </li>
                <li>5.2.7. 利用本軟體發表、傳送、傳播、儲存違反當地法律法規的內容；</li>
                <li>5.2.8. 利用本軟體發表、傳送、傳播、儲存侵害他人智慧財產權、商業秘密等合法權利的內容；</li>
                <li>5.2.9. 利用本軟體批次發表、傳送、傳播廣告信息及垃圾信息；</li>
                <li>5.2.10. 其他以任何不合法的方式、為任何不合法的目的、或以任何與本協議許可使用不一致的方式使用本軟體和追覓提供的其他服務；</li>
            </ul>
            <p>5.3. 資訊釋出規範</p>
            <ul>
                <li>5.3.1．您可使用本軟體發表屬於您原創或您有權發表的觀點看法、資料、文字、資訊、使用者名稱、圖片、照片、個人資訊、音訊、影片檔案、連結等資訊內容。您必須保證，您擁有您所上傳資訊內容的智慧財產權或已獲得合法授權，您使用本軟體及服務的任何行為未侵犯任何第三方之合法權益。
                </li>
                <li>5.3.2．您在使用本軟體時需遵守當地法律法規要求。</li>
                <li>5.3.3．您在使用本軟體時不得利用本軟體從事以下行為，包括但不限於：</li>
            </ul>
            <p>5.3.3.1.製作、複製、釋出、傳播、儲存違反當地法律法規的內容；</p>
            <p>5.3.3.2.釋出、傳送、傳播、儲存侵害他人名譽權、肖像權、智慧財產權、商業秘密等合法權利的內容；</p>
            <p>5.3.3.3.虛構事實、隱瞞真相來誤導、欺騙他人；</p>
            <p>5.3.3.4.發表、傳送、傳播廣告信息及垃圾信息；</p>
            <p>5.3.3.5.從事其他違反當地法律法規的行為。</p>
            <p>5.3.3.6未經追覓許可，您不得在本軟體中進行任何諸如釋出廣告、銷售商品的商業行為。</p>
            <p><strong>5.4.</strong>您理解並同意：</p>
            <ul>
                <li>5.4.1. 追覓會對使用者是否涉嫌違反上述使用規範做出認定，並根據認定結果中止、終止對您的使用許可或採取其他依本約定可採取的限制措施；</li>
                <li>5.4.2. 對於使用者使用許可軟體時釋出的涉嫌違法或涉嫌侵犯他人合法權利或違反本協議的資訊，追覓會直接刪除；</li>
                <li>5.4.3. 對於使用者違反上述使用規範的行為對第三方造成損害的，您需要以自己的名義獨立承擔法律責任，並應確保追覓免於因此產生損失或增加費用；</li>
                <li>5.4.4．若使用者違反有關法律規定或協議約定，使追覓遭受損失，或受到第三方的索賠，或受到行政管理機關的處罰，使用者應當賠償追覓因此造成的損失和（或）發生的費用，包括合理的律師費、調查取證費用。</li>
            </ul>
            <p>六、軟體授權</p>
            <p>6.1. 在使用者同意遵守本協議及其《Dreamehome隱私政策》的情況下，追覓就本軟體給予使用者在其所在國境內一項個人的、不可轉讓、不可轉授權以及非獨佔性的有限許可。</p>
            <p>6.2.
                使用者可以為非商業目的在單一台行動終端設備上安裝、使用、顯示、執行本軟體。但使用者不得為商業運營目的安裝、使用、執行本軟體，不可以對本軟體或者本軟體運行過程中釋放到任何終端裝置記憶體中的資料及本軟體執行過程中客戶端與伺服器端的互動資料進行複製、更改、修改、掛接執行或創作任何衍生作品，形式包括但不限於使用插件、外掛或非經授權的第三方工具/服務接入本軟體和相關系統。如果需要進行商業性的銷售、複製和散發，例如軟體預裝和捆綁，必須獲得追覓的書面授權和許可。
            </p>
            <p>6.3 6.3 使用者不得未經追覓許可，將本軟體安裝在未經追覓明示許可的其他終端裝置上，包括但不限於數位視訊轉換盒、遊戲機、電視機、DVD機等。</p>
            <p>6.4. 使用者可以為使用本軟體及服務的目的複製本軟體的一個副本，僅用作備份。備份副本必須包含原軟體中含有的所有著作權資訊。</p>
            <p>6.5. 除本《協議》明示授權外，追覓未授權給使用者其他權利，若使用者使用其他權利時須另外取得追覓的書面同意。</p>
            <p>七、責任限制及免責宣告</p>
            <p>7.1. 責任限制</p>
            <p>在您所在司法轄區適用法律允許的最大範圍內，您將自行承擔訪問和使用本軟體及服務可能面臨的風險。追覓明確排除因以下情形由您或其他任何人造成的責任、損失或損害，無論是基於合同、侵權（包括過失侵權）或其它任何依據：</p>
            <p>（<strong>1</strong>）<strong> </strong>利潤損失、收入損失、收益損失、資料丟失或商譽損失；</p>
            <p>（<strong>2</strong>）<strong> </strong>有關的人身傷害、特別、間接或衍生性損失或損害。無論追覓是否已經知悉或是否應該意識到上述損失出現的可能性，本協議中的限制和排除條款都將適用。</p>
            <p>在您所在司法轄區適用法律允許的最大範圍內，無論您何時對本軟體及服務的任何方面感到不滿意，您唯一的救濟措施都是停止訪問和使用本軟體及服務。在不影響前述限制的情況下，在您所在地司法轄區適用法律允許的最大範圍內，追覓對您或其他人的任何索償、訴訟、責任、義務、損害、損失及成本的累計責任都不超過您使用本軟體及服務支付的價款，無論是基於合同、侵權（包括過失侵權）或其它任何依據。您理解並同意本協議中的免責聲明與責任限制公平合理
            </p>
            <p>7.2.免責宣告</p>
            <p>在您所在司法轄區適用法律允許的最大範圍內，對於您或其他任何人因下列原因無法訪問或使用本軟體及服務導致的任何責任、損失、損害或賠償，追覓及其合作方不承擔任何責任：</p>
            <p><strong>(1) </strong>追覓對系統或軟硬件進行維護或升級導致本軟體及服務中止或終止；</p>
            <p><strong>(2) </strong>使用者因第三方如通訊線路故障、技術問題、網路、行動終端裝置故障、系統不穩定性及其他各種不可抗力原因而遭受的一切損失；</p>
            <p><strong>(3)
            </strong>本軟體如同大多數網際網路軟體一樣，受包括但不限於使用者原因、網路服務品質、社會環境等因素的差異影響，可能受到各種安全問題的侵擾，如他人利用使用者的資料，造成現實生活中的騷擾；使用者下載安裝的其它軟體或訪問的其他網站中含有「特洛伊木馬」等病毒，威脅到使用者的終端裝置資訊和資料的安全，繼而影響本軟體的正常使用等等；
            </p>
            <p><strong>(4) </strong>本軟體調用第三方系統或第三方軟體支持使用者的使用或訪問，其結果的安全性、準確性、有效性及其他不確定的風險，並因此所引發的任何爭議及損害</p>
            <p><strong>(5) </strong>超越追覓合理控制的其它原因。</p>
            <p><strong>7.3.
            </strong>部分國家的法律不允許合同中排除或限制某些保證、擔保或責任。若這些法律適用於您，則前述排除或限制條款的全部或部分可能不適用於您，您可享有額外的權利。本協議中的任何內容均不影響您作為消費者應該享有的法定權利，您也無法通過同意本合同變更或放棄這些權利。
            </p>
            <p>八、第三方內容<strong>/</strong>服務說明</p>
            <p>8.1.
                追覓會不時與第三方網站、社交媒體平台、行動應用程式以及其他商品或服務（「第三方」）連結或合作。您能夠通過平台與該第三方互動，但這不代表追覓認可、監控或控制此類第三方或其行為，這些第三方及其行為受單獨的使用條款和隱私政策的約束。您應仔細閱讀任何第三方網站及其使用條款和隱私政策。追覓不對第三方的內容、政策或活動負責，且您自行承擔使用第三方內容和服務的風險。
            </p>
            <p>8.2. 使用者與第三方內容或服務提供方之間發生的任何爭議、糾紛應由使用者與第三方服務提供方自行協商解決，追覓不承擔任何責任。</p>
            <p>九、智慧財產權宣告</p>
            <p>9.1
                除另有特別宣告外，我們在本協議項下提供的產品和服務中的內容（包括但不限於頁面、文字、圖片、音訊、影片、圖表等）、提供產品和服務時所依託應用程式、以及在產品和服務中所使用的商標及其他商業標識，其著作權、專利權、商標權或其他相關智慧財產權和合法權益均歸我們所有。
            </p>
            <p>9.2 上述及其他任何我們的產品和服務中所包含的內容的智慧財產權均受到法律保護，未經我們或相關權利人事先書面許可，任何人不得以任何形式進行使用或創造相關衍生作品。</p>
            <p>十、協議的修改和終止</p>
            <p>10.1.一些司法管轄區不允許單方面更新或變更消費條款，因此本段可能對您不適用。在您所在司法轄區適用法律允許的最大範圍內：</p>
            <p>（1）我們可能會不時更新這些條款。如果發生重大變更，我們將在Dreamehome或我們的官網上釋出通知或向您傳送通知。請閱讀全部變更。如果您不同意任何變更，請停止使用Dreamehome。如果在我們通知您變更後您繼續使用我們的Dreamehome，除非適用法律禁止，您將被視為已接受了更新後的條款。
            </p>
            <p>（2）追覓和合作公司有權按需要修改或變更所提供的收費服務、收費標準、收費方式、服務費及服務條款。追覓在提供服務時，可能現在或日後對部分服務的使用者開始收取一定的費用如使用者拒絕支付該等費用，則不能在收費開始後繼續使用相關的服務。追覓和合作公司將盡最大努力透過電郵或其他方式通知使用者有關的修改或變更。
            </p>
            <p>（3）追覓保留在任何時候無需通知而修改、保留或關閉Dreamehome及其服務的權力。使用者已同意追覓無需因修改、保留或關閉Dreamehome及其服務的行為對使用者或第三方承擔責任。</p>
            <p>（4）依據適用法律，追覓可以不承擔任何責任地在任何時間因任何原因終止或暫停使用者的帳戶、刪除您的檔案或任何使用者內容，或者限制您使用全部或部分本軟體及服務。</p>
            <p>（5）本條款在您的賬戶終止或您停止使用本軟體及服務後仍然有效。</p>
            <p>十一、適用法律及爭議解決</p>
            <p>11.1. 如果您在美國居住，則本協議將按照加利福尼亞州和美國法律解釋，而不考慮法律衝突條文。因本協議而產生或與使用本軟體及服務有關的任何爭議應提交至位於加利福尼亞州舊金山的州或聯邦法院，除非雙方一致同意在其他地點進行訴訟。
                您和我們均同意加利福尼亞州舊金山市作為審理地點並接受其屬人管轄。</p>
            <p>11.2．如果您在歐洲經濟體或英國居住，您同本協議在所有方面均受荷蘭法律管轄，但法律衝突規則除外，也不適用1980年《聯合國國際貨物銷售合同公約》。</p>
            <p>除禁止和限制消費者的任何法定權利的情形外，您因本協議產生之爭議的法律程序應得到解決並排他地受荷蘭阿姆斯特丹的適格法院管轄，但法律衝突規則除外</p>
            <p>如果您有任何投訴意見，請透過聯繫我們與我們聯繫。如果您覺得您的投訴沒有得到充分解決，您可以，但沒有義務，通過<a className="page"
                href="http://ec.europa.eu/odr">http://ec.europa.eu/odr</a>訪問在線爭議解決（ODR）平台。此外，您有權通過以下方式聯繫調解員來啓動調解程序：歐洲調解員協會（197，Boulevard
                Saint-Germain，75007 巴黎，聯繫電話：09 53 01 02 69），<a className="page"
                    href="http://www.mediationconso-ame.com/">http://www.mediationconso-ame.com/</a>。調解員將試圖獨立和公正地達成和解。在調解的情況下，各方可以自由接受或拒絕調解員提出的解決方案。
            </p>
            <p>11.3. 如果您在11.1和11.2款以外的國家及地區居住，則本協議受中華人民共和國法律管轄。
                在這種情況下，因本協議而產生或與使用本軟體及服務有關的任何爭議應提交上海國際經濟貿易仲裁委員會（「貿仲委」）進行仲裁，仲裁應根據申請仲裁時有效的貿仲委仲裁規則進行。 仲裁裁決是最終裁決，對雙方均有約束力。 仲裁庭應由三
                (3) 名仲裁員組成。仲裁地點應為上海。 仲裁語言應為中文。</p>
            <p>十二、其他</p>
            <p>12.1. 隱私政策</p>
            <p>追覓非常重視您的個人隱私資訊，請認真查閱我們的《Dreamehome隱私政策》，《Dreamehome隱私政策》為與本協議效力等同且不可分割的一部分。在任何時候，您的資訊均依照《Dreamehome隱私政策》處理</p>
            <p>12.2. 本協議生效時間為2021年8月28日。</p>
            <p>12.3. 本協議所有條款的標題僅為閱讀方便，本身並無實際涵義，不能作為本協議涵義解釋的依據。</p>
            <div className='height'></div>
        </div>
    )
}
export default License